var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormHelperText, IconButton, TextField, Typography } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useUpdateSpecialityMutation } from '../../../../../application/features/specialities/speciality-api';
import useTranslate from '../../../../../localization/helpers';
import { X } from 'react-feather';
var EditSpecialty = function (_a) {
    var open = _a.open, onClose = _a.onClose, speciality = _a.speciality;
    var _b = useTranslate(), translate = _b.translate, tWithField = _b.tWithField, tWithFunction = _b.tWithFunction;
    var _c = __read(useUpdateSpecialityMutation(), 2), updateSpeciality = _c[0], _d = _c[1], isLoading = _d.isLoading, isSuccess = _d.isSuccess;
    var _e = useForm({
        defaultValues: {
            name: ''
        }
    }), control = _e.control, handleSubmit = _e.handleSubmit, reset = _e.reset, errors = _e.formState.errors;
    useEffect(function () {
        if (speciality)
            reset(speciality);
    }, [speciality, reset]);
    useEffect(function () {
        if (isSuccess) {
            enqueueSnackbar(tWithField('toolTips.updateSuccess', 'common.speciality'), {
                autoHideDuration: 3000,
                variant: 'success',
                anchorOrigin: { horizontal: 'right', vertical: 'top' }
            });
            closeDialog();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSuccess]);
    var closeDialog = function () {
        reset();
        onClose();
    };
    var onSubmit = function (speciality) { return updateSpeciality(speciality); };
    return (_jsxs(Dialog, { open: open, fullWidth: true, maxWidth: 'sm', onClose: onClose, children: [_jsxs(DialogTitle, { style: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }, children: [_jsx(Typography, { variant: 'h6', children: tWithFunction('actions.updateFunction', 'common.speciality') }), _jsx(IconButton, { size: 'Xs', style: { marginLeft: 'auto' }, onClick: onClose, children: _jsx(X, { color: '#637381' }) })] }), _jsx(DialogContent, { children: _jsx(Controller, { name: 'name', control: control, rules: {
                        required: {
                            value: true,
                            message: tWithField('validations.fieldIsRequired', 'settings.technicianSpecialties.specialtyName')
                        },
                        maxLength: {
                            value: 128,
                            message: translate('validations.maximumCharactersAllowed', { count: 128 })
                        }
                    }, render: function (_a) {
                        var _b;
                        var _c = _a.field, onChange = _c.onChange, value = _c.value;
                        return (_jsxs(FormControl, { fullWidth: true, sx: { my: '10px' }, children: [_jsx(TextField, { disabled: isLoading, fullWidth: true, label: translate('settings.technicianSpecialties.specialtyName'), value: value, onChange: onChange, error: !!errors.name }), _jsx(FormHelperText, { error: true, children: (_b = errors.name) === null || _b === void 0 ? void 0 : _b.message })] }));
                    } }) }), _jsxs(DialogActions, { children: [_jsx(Button, { disabled: isLoading, onClick: closeDialog, variant: 'outlined', color: 'inherit', children: translate('actions.cancel') }), _jsx(Button, { disabled: isLoading, onClick: handleSubmit(onSubmit), color: 'warning', variant: 'contained', children: translate('actions.saveChanges') })] })] }));
};
export default EditSpecialty;
